// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import StackedBarChartRoundedIcon from '@mui/icons-material/StackedBarChartRounded';
import ViewColumnRoundedIcon from '@mui/icons-material/ViewColumnRounded';

// material ui
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';

// components
import useSearchParams from '@/hooks/useStableSearchParams';

/**
 * StackedDataToggle
 * - Reusable toggle for switching between aggregated and stacked data views
 * - State is persisted in URL search params
 */
const StackedDataToggle = () => {
  const { t } = useTranslation('dashboards-common');
  const [searchParams, setSearchParams] = useSearchParams();

  const value = searchParams.get('stacked') === 'true' ? 'stacked' : 'column';

  const handleChange = (_, nextValue) => {
    if (!nextValue) return;

    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (nextValue === 'stacked') {
        next.set('stacked', 'true');
      } else {
        next.delete('stacked');
      }
      return next;
    });
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={handleChange}
        aria-label={t('chart.displayMode.label')}
      >
        <ToggleButton
          value="stacked"
          aria-label={t('chart.displayMode.stacked')}
        >
          <StackedBarChartRoundedIcon fontSize="small" sx={{ mr: 0.5 }} />
          {t('chart.displayMode.stacked')}
        </ToggleButton>
        <ToggleButton value="column" aria-label={t('chart.displayMode.column')}>
          <ViewColumnRoundedIcon fontSize="small" sx={{ mr: 0.5 }} />
          {t('chart.displayMode.column')}
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};

export default StackedDataToggle;
